export const apiUrls = {
  dashboardAPIUrl: '/v1/fetch/user/partnership/dashboard/details',
  gstV2Details: '/v2/erp/gst/details',
  cinPresent: '/check/cin/present',
  getAllPartnershipAPI: '/v1/fetch/user/partnerships',
  fetchUserDetailsAPI: '/v1/fetch/user',
  fetchCommomTasksAPI: '/api/v4/user/details',
  fetchCompanyProfileAPI: '/v1/fetch/company/user',
  submitBankDetails: '/v1/submit/bank/detail',
  ifsc: '/v1/fetch/detail/ifsc/',
  logOut: '/v2/logout',
  sendUserOTP: '/otp/v2/send',
  sendUserOTPV3: '/otp/v3/send',
  validateOTP: '/otp/v2/validate',
  signUp: '/v4/signup',
  RsaKey: '/v1/fetch/publicKey',
  GraphConfig: '/v1/fetch/graphConfiguration',
  addPartnership: '/v1/add/user-partnership/fetch/tasks',
  GraphData: '/v1/fetch/graph/details',
  policyData: '/policy/document/v1/get/group',
  policyFetch: '/policy/document/v1/fetch',
  policySubmit: '/policy/document/v1/submit',
  fetchUserData: '/v1/fetch/user',
  saveUserProfile: '/v1/updateUserDetails',
  fetchInvoice: '/v2/list/invoice/',
  fetchReceipt: '/list/receipt/',
  fetchSelectedInvoice: '/v1/invoice/fetch',
  fetchSelectedReceipt: '/v1/receipt/fetch',
  reportingFilter: '/v2/fetch/reporting/details',
  updateUserProfile: '/user/v2/update/profile',
  getLicenseMandate: '/lcoUserService/user/isBlocked',
  addEmployee: 'api/v1/add/employee',
  aadhaarOtp: 'api/v1/aadhar/otp/send',
  faceRecognition: 'api/v1/employee/fetch/recognition',
  fetchTeamDetails: 'api/v1/employee/list',
  fetchTurboIvp: '/v1/generate/ivp/token',
  forgotPassword: '/user/password/v2/reset',
  resetPassword: '/user/password/v2/update',
  fetchRoles: 'api/v1/employee/roles',
  refreshToken: '/token/v2/refresh',
  submitContactDetails: '/lead/add',
  validateOtpV3: '/otp/v3/validate',
  getVendorDetails: '/api/v2/erp/vendor/details/by/pan',
  downloadEFT: '/file/eft/document/download',
  downloadDeboardEFT: '/api/v1/eft/document/download',
  uploadEFT: '/file/eft/document/upload',
  uploadDeboardEFT: '/api/v1/eft/document/upload',
  updateOtpValidation: '/api/v1/user/update/otpValidation',
  pendingInvoiceStatus: '/api/v1/fnf/invoice/status',
  acceptGstPenalty: '/api/v1/gst/penalty/accept',
  acceptFST: '/api/v1/fnf/fst/isAccepted',
  downloadFSTDoc: '/api/v1/document/download/',
  getFSTBreakUp: '/api/v1/fnf/summary',
  uploadDocument: '/api/v1/document/upload',
  deleteDocument: '/api/v1/document/delete',
  validateDocuments: '/api/v1/fnf/required/document',
  ESignDoc: '/api/v1/fnf/contract/generate',
  fnfInitiate: '/api/v1/fnf/initiate',
  updateBankDetails: '/v1/update/bank/detail',
  sendDualotp: '/otp/v3/sendDualOTP',
  skipUpdateAccount: '/api/v1/fnf/state/process',
  fnfDetails: '/api/v1/fnf/user/details',
  addnUpload: '/api/v1/document/additional/upload',
  downloadContractDocument: '/contract/v2/fetch/contract',
  erpBankDetails: "/api/v2/erp/bank/details",
  uploadApproverDocument: "/api/v1/approver/document/upload",
  preferredDashboard: '/user/v1/preferred-dashboard',
  getVendorDetailsV2: '/api/v3/erp/bank/details'
};

export const befeUrls = {
  landing: 'team/landingPage',
  login: 'team/loginPage',
  fnfJourney: 'team/fnf/journey'
};
